import React from 'react';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="container">
      <div className="card" style={{ textAlign: 'center' }}>
        <h1>Send parcels across Zambia</h1>
        <p style={{ color: '#6b7280' }}>
          Book pickup from your door. Track every step. Delivered to any city.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginTop: 16 }}>
          <Link to="/book" className="btn btn-primary">Book a Parcel</Link>
          <Link to="/track" className="btn" style={{ background: '#fff', border: '1px solid #dc2626', color: '#dc2626' }}>Track a Parcel</Link>
        </div>
      </div>
      <div className="card">
        <h2>Lusaka ↔ Kitwe</h2>
        <p style={{ color: '#6b7280' }}>Phase 1 lane. More cities coming.</p>
      </div>
    </div>
  );
}
